import * as React from 'react';
import styled from 'styled-components';
import { DialGauge } from '../../../designSystem/graphs/DialGauge';
import { Flex } from '../../../designSystem/compositeComponents/FlexHelpers';
import { Card } from '../../../designSystem/Card';
import { H3 } from '../../../designSystem/typography/Heading';
import { colors } from '../../../designSystem/colors/color';
import { ChipVariant, InfoChip } from '../../../designSystem/Chip';

type ThanksPageScoreProps = {
    overallScorePct: number;
    overallBenchmarkScorePct: number;
};

const gaugeSegments = 20;

export function ThanksPageScore(props: ThanksPageScoreProps): JSX.Element {
    const selectedGaugeSegments = Math.round((props.overallScorePct / 100) * gaugeSegments);
    const selectedBenchmarkGaugeSegments = Math.round((props.overallBenchmarkScorePct / 100) * gaugeSegments);

    return (
        <Flex flexDirection="column" gap={16} alignItems="center">
            <Flex justifyContent='center' gap={32} flexWrap='wrap'>
                
                <Flex flexDirection='column' alignItems='center' gap={8}>
                    <GaugeCard header='Din score' scorePct={props.overallScorePct} segments={selectedGaugeSegments} />
                    <InfoChip variant={resolveStatusBgColor(props.overallScorePct)}>
                        <RatingText>{resolveRatingText(props.overallScorePct)}</RatingText>
                    </InfoChip>
                </Flex>

                <Flex flexDirection='column' alignItems='center' gap={8}>
                    <GaugeCard header='Benchmark' scorePct={props.overallBenchmarkScorePct} segments={selectedBenchmarkGaugeSegments} />
                </Flex>
            </Flex>
        </Flex>
    );
}

type GaugeCardProps = {
    header:string,
    segments:number,
    scorePct:number
}
function GaugeCard(props:GaugeCardProps):JSX.Element
{
    return (
        <Card variant="outlined">
            <Flex flexDirection="column" alignItems="center" gap={8}>
                <H3>{props.header}</H3>
                <DialGauge
                    segments={gaugeSegments}
                    selectedSegments={props.segments}
                    color={resolveStatusBgColor(props.scorePct)}
                    widthPx={220}
                />
                <ScoreValue>{props.scorePct}%</ScoreValue>
            </Flex>
        </Card>
    );
}

function resolveRatingText(scorePct: number): string {
    if (scorePct >= 90)
        return 'Stærk profil';
    if (scorePct >= 70)
        return 'Acceptabelt med forbedringspotentiale';

    return 'Kræver handling';
}

function resolveStatusBgColor(scorePct: number):ChipVariant {
    if (scorePct >= 90)
        return 'filled';

    if (scorePct >= 70)
        return 'outlined';

    return 'warning';
}

function resolveStatusTextColor(scorePct: number): string {
    if(scorePct < 70)
        return colors.text.normal;

    return colors.text.white;
}

const ScoreValue = styled.p`
    margin: 0;
    font-size: 1.5rem;
    font-weight: 700;
`;

const RatingText = styled.span`
    font-size: 0.8rem;
    font-weight: 600;
`;
